import * as React from 'react';

import cn from 'classnames';

import { breakpoints } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { ICurrencyProps } from './Currency';
import LineHeight from './LineHeight';
import { IWrapperProps } from './Wrapper';

const CurrencySpan = styled.span<ICurrencyProps>`
  font-size: 1.5rem;
  font-weight: normal;

  @media (min-width: ${breakpoints.sm}) {
    font-size: 2rem;
  }
`;

const currencySpacedAndPrefixedClass = css`
  &:after {
    content: ' ';
  }
`;

const currencySpacedAndSuffixedClass = css`
  &:before {
    content: ' ';
  }
`;

export const CurrencyStyled = (props: ICurrencyProps) => (
  <CurrencySpan
    {...props}
    className={cn(
      {
        [currencySpacedAndPrefixedClass]: props.isSpaced && props.isPrefix,
        [currencySpacedAndSuffixedClass]: props.isSpaced && !props.isPrefix,
      },
      props.className
    )}
  />
);

export const Wrapper = styled.div<IWrapperProps>`
  font-weight: bold;
  font-size: 1.87rem;
  -webkit-flex-grow: 0;
  flex-grow: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  line-height: ${LineHeight.NORMAL};
  white-space: nowrap;

  @media (min-width: ${breakpoints.sm}) {
    font-size: 2.6rem;
    line-height: ${(props) => props.lineHeight || LineHeight.NORMAL};
  }
`;

export const PD_PRICE_WRAPPER_TEST_ID = 'pd-price-wrapper';
